/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { CreateFileRoute, FileRoutesByPath } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FinalizeUserRouteImport } from './routes/finalize-user'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PaymentSuccessRouteImport } from './routes/payment/success'
import { Route as PaymentCancelRouteImport } from './routes/payment/cancel'
import { Route as AccessRedeemRouteImport } from './routes/access/redeem'
import { Route as AuthenticatedTosAcceptanceRouteImport } from './routes/_authenticated/tos-acceptance'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedServiceProvidersRouteImport } from './routes/_authenticated/service-providers'
import { Route as AuthenticatedRecordsRouteImport } from './routes/_authenticated/records'
import { Route as AuthenticatedPropertiesRouteImport } from './routes/_authenticated/properties'
import { Route as AuthenticatedProfileSetupRouteImport } from './routes/_authenticated/profile-setup'
import { Route as AuthenticatedMaintenanceRouteImport } from './routes/_authenticated/maintenance'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSetupIndexRouteImport } from './routes/_authenticated/setup/index'
import { Route as PropertyPropertyPublicIdGuestAccessRouteImport } from './routes/property/$propertyPublicId/guest-access'
import { Route as PaymentProSuccessRouteImport } from './routes/payment/pro/success'
import { Route as PaymentProCancelRouteImport } from './routes/payment/pro/cancel'
import { Route as AccessTokenDenyRouteImport } from './routes/access/$token/deny'
import { Route as AccessTokenApproveRouteImport } from './routes/access/$token/approve'
import { Route as AuthenticatedSetupNewRouteImport } from './routes/_authenticated/setup/new'
import { Route as AuthenticatedSettingsTransferRouteImport } from './routes/_authenticated/settings/transfer'
import { Route as AuthenticatedSettingsPropertyRouteImport } from './routes/_authenticated/settings/property'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated/settings/api-keys'
import { Route as AuthenticatedSettingsAccessRouteImport } from './routes/_authenticated/settings/access'
import { Route as AuthenticatedPropertyPropertyPublicIdRouteImport } from './routes/_authenticated/property/$propertyPublicId'
import { Route as AuthenticatedOauthConsentRouteImport } from './routes/_authenticated/oauth/consent'
import { Route as AuthenticatedPropertyPropertyPublicIdIndexRouteImport } from './routes/_authenticated/property/$propertyPublicId/index'
import { Route as AuthenticatedPropertyPropertyPublicIdStagedDocumentsRouteImport } from './routes/_authenticated/property/$propertyPublicId/staged-documents'
import { Route as AuthenticatedPropertyPropertyPublicIdSettingsRouteImport } from './routes/_authenticated/property/$propertyPublicId/settings'
import { Route as AuthenticatedPropertyPropertyPublicIdServiceProvidersRouteImport } from './routes/_authenticated/property/$propertyPublicId/service-providers'
import { Route as AuthenticatedPropertyPropertyPublicIdScheduleRouteImport } from './routes/_authenticated/property/$propertyPublicId/schedule'
import { Route as AuthenticatedPropertyPropertyPublicIdRecordsRouteImport } from './routes/_authenticated/property/$propertyPublicId/records'
import { Route as AuthenticatedPropertyPropertyPublicIdArchiveRouteImport } from './routes/_authenticated/property/$propertyPublicId/archive'
import { Route as AuthenticatedPropertyPropertyPublicIdSettingsIndexRouteImport } from './routes/_authenticated/property/$propertyPublicId/settings/index'
import { Route as AuthenticatedPropertyPropertyPublicIdSettingsTransferRouteImport } from './routes/_authenticated/property/$propertyPublicId/settings/transfer'
import { Route as AuthenticatedPropertyPropertyPublicIdSettingsAccessRouteImport } from './routes/_authenticated/property/$propertyPublicId/settings/access'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FinalizeUserRoute = FinalizeUserRouteImport.update({
  id: '/finalize-user',
  path: '/finalize-user',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
  id: '/payment/success',
  path: '/payment/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCancelRoute = PaymentCancelRouteImport.update({
  id: '/payment/cancel',
  path: '/payment/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRedeemRoute = AccessRedeemRouteImport.update({
  id: '/access/redeem',
  path: '/access/redeem',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTosAcceptanceRoute =
  AuthenticatedTosAcceptanceRouteImport.update({
    id: '/tos-acceptance',
    path: '/tos-acceptance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedServiceProvidersRoute =
  AuthenticatedServiceProvidersRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRecordsRoute = AuthenticatedRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPropertiesRoute = AuthenticatedPropertiesRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileSetupRoute =
  AuthenticatedProfileSetupRouteImport.update({
    id: '/profile-setup',
    path: '/profile-setup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMaintenanceRoute =
  AuthenticatedMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSetupIndexRoute = AuthenticatedSetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const PropertyPropertyPublicIdGuestAccessRoute =
  PropertyPropertyPublicIdGuestAccessRouteImport.update({
    id: '/property/$propertyPublicId/guest-access',
    path: '/property/$propertyPublicId/guest-access',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentProSuccessRoute = PaymentProSuccessRouteImport.update({
  id: '/payment/pro/success',
  path: '/payment/pro/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentProCancelRoute = PaymentProCancelRouteImport.update({
  id: '/payment/pro/cancel',
  path: '/payment/pro/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessTokenDenyRoute = AccessTokenDenyRouteImport.update({
  id: '/access/$token/deny',
  path: '/access/$token/deny',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessTokenApproveRoute = AccessTokenApproveRouteImport.update({
  id: '/access/$token/approve',
  path: '/access/$token/approve',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSetupNewRoute = AuthenticatedSetupNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const AuthenticatedSettingsTransferRoute =
  AuthenticatedSettingsTransferRouteImport.update({
    id: '/transfer',
    path: '/transfer',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPropertyRoute =
  AuthenticatedSettingsPropertyRouteImport.update({
    id: '/property',
    path: '/property',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAccessRoute =
  AuthenticatedSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdRoute =
  AuthenticatedPropertyPropertyPublicIdRouteImport.update({
    id: '/property/$propertyPublicId',
    path: '/property/$propertyPublicId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOauthConsentRoute =
  AuthenticatedOauthConsentRouteImport.update({
    id: '/oauth/consent',
    path: '/oauth/consent',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdIndexRoute =
  AuthenticatedPropertyPropertyPublicIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute =
  AuthenticatedPropertyPropertyPublicIdStagedDocumentsRouteImport.update({
    id: '/staged-documents',
    path: '/staged-documents',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdSettingsRoute =
  AuthenticatedPropertyPropertyPublicIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute =
  AuthenticatedPropertyPropertyPublicIdServiceProvidersRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdScheduleRoute =
  AuthenticatedPropertyPropertyPublicIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdRecordsRoute =
  AuthenticatedPropertyPropertyPublicIdRecordsRouteImport.update({
    id: '/records',
    path: '/records',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdArchiveRoute =
  AuthenticatedPropertyPropertyPublicIdArchiveRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute =
  AuthenticatedPropertyPropertyPublicIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdSettingsRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute =
  AuthenticatedPropertyPropertyPublicIdSettingsTransferRouteImport.update({
    id: '/transfer',
    path: '/transfer',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdSettingsRoute,
  } as any)
const AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute =
  AuthenticatedPropertyPropertyPublicIdSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedPropertyPropertyPublicIdSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/finalize-user': typeof FinalizeUserRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/maintenance': typeof AuthenticatedMaintenanceRoute
  '/profile-setup': typeof AuthenticatedProfileSetupRoute
  '/properties': typeof AuthenticatedPropertiesRoute
  '/records': typeof AuthenticatedRecordsRoute
  '/service-providers': typeof AuthenticatedServiceProvidersRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/setup': typeof AuthenticatedSetupRouteWithChildren
  '/tos-acceptance': typeof AuthenticatedTosAcceptanceRoute
  '/access/redeem': typeof AccessRedeemRoute
  '/payment/cancel': typeof PaymentCancelRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/oauth/consent': typeof AuthenticatedOauthConsentRoute
  '/property/$propertyPublicId': typeof AuthenticatedPropertyPropertyPublicIdRouteWithChildren
  '/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/property': typeof AuthenticatedSettingsPropertyRoute
  '/settings/transfer': typeof AuthenticatedSettingsTransferRoute
  '/setup/new': typeof AuthenticatedSetupNewRoute
  '/access/$token/approve': typeof AccessTokenApproveRoute
  '/access/$token/deny': typeof AccessTokenDenyRoute
  '/payment/pro/cancel': typeof PaymentProCancelRoute
  '/payment/pro/success': typeof PaymentProSuccessRoute
  '/property/$propertyPublicId/guest-access': typeof PropertyPropertyPublicIdGuestAccessRoute
  '/setup/': typeof AuthenticatedSetupIndexRoute
  '/property/$propertyPublicId/archive': typeof AuthenticatedPropertyPropertyPublicIdArchiveRoute
  '/property/$propertyPublicId/records': typeof AuthenticatedPropertyPropertyPublicIdRecordsRoute
  '/property/$propertyPublicId/schedule': typeof AuthenticatedPropertyPropertyPublicIdScheduleRoute
  '/property/$propertyPublicId/service-providers': typeof AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute
  '/property/$propertyPublicId/settings': typeof AuthenticatedPropertyPropertyPublicIdSettingsRouteWithChildren
  '/property/$propertyPublicId/staged-documents': typeof AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute
  '/property/$propertyPublicId/': typeof AuthenticatedPropertyPropertyPublicIdIndexRoute
  '/property/$propertyPublicId/settings/access': typeof AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute
  '/property/$propertyPublicId/settings/transfer': typeof AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute
  '/property/$propertyPublicId/settings/': typeof AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/finalize-user': typeof FinalizeUserRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/maintenance': typeof AuthenticatedMaintenanceRoute
  '/profile-setup': typeof AuthenticatedProfileSetupRoute
  '/properties': typeof AuthenticatedPropertiesRoute
  '/records': typeof AuthenticatedRecordsRoute
  '/service-providers': typeof AuthenticatedServiceProvidersRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/tos-acceptance': typeof AuthenticatedTosAcceptanceRoute
  '/access/redeem': typeof AccessRedeemRoute
  '/payment/cancel': typeof PaymentCancelRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/oauth/consent': typeof AuthenticatedOauthConsentRoute
  '/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/property': typeof AuthenticatedSettingsPropertyRoute
  '/settings/transfer': typeof AuthenticatedSettingsTransferRoute
  '/setup/new': typeof AuthenticatedSetupNewRoute
  '/access/$token/approve': typeof AccessTokenApproveRoute
  '/access/$token/deny': typeof AccessTokenDenyRoute
  '/payment/pro/cancel': typeof PaymentProCancelRoute
  '/payment/pro/success': typeof PaymentProSuccessRoute
  '/property/$propertyPublicId/guest-access': typeof PropertyPropertyPublicIdGuestAccessRoute
  '/setup': typeof AuthenticatedSetupIndexRoute
  '/property/$propertyPublicId/archive': typeof AuthenticatedPropertyPropertyPublicIdArchiveRoute
  '/property/$propertyPublicId/records': typeof AuthenticatedPropertyPropertyPublicIdRecordsRoute
  '/property/$propertyPublicId/schedule': typeof AuthenticatedPropertyPropertyPublicIdScheduleRoute
  '/property/$propertyPublicId/service-providers': typeof AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute
  '/property/$propertyPublicId/staged-documents': typeof AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute
  '/property/$propertyPublicId': typeof AuthenticatedPropertyPropertyPublicIdIndexRoute
  '/property/$propertyPublicId/settings/access': typeof AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute
  '/property/$propertyPublicId/settings/transfer': typeof AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute
  '/property/$propertyPublicId/settings': typeof AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/finalize-user': typeof FinalizeUserRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/maintenance': typeof AuthenticatedMaintenanceRoute
  '/_authenticated/profile-setup': typeof AuthenticatedProfileSetupRoute
  '/_authenticated/properties': typeof AuthenticatedPropertiesRoute
  '/_authenticated/records': typeof AuthenticatedRecordsRoute
  '/_authenticated/service-providers': typeof AuthenticatedServiceProvidersRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/setup': typeof AuthenticatedSetupRouteWithChildren
  '/_authenticated/tos-acceptance': typeof AuthenticatedTosAcceptanceRoute
  '/access/redeem': typeof AccessRedeemRoute
  '/payment/cancel': typeof PaymentCancelRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/_authenticated/oauth/consent': typeof AuthenticatedOauthConsentRoute
  '/_authenticated/property/$propertyPublicId': typeof AuthenticatedPropertyPropertyPublicIdRouteWithChildren
  '/_authenticated/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/property': typeof AuthenticatedSettingsPropertyRoute
  '/_authenticated/settings/transfer': typeof AuthenticatedSettingsTransferRoute
  '/_authenticated/setup/new': typeof AuthenticatedSetupNewRoute
  '/access/$token/approve': typeof AccessTokenApproveRoute
  '/access/$token/deny': typeof AccessTokenDenyRoute
  '/payment/pro/cancel': typeof PaymentProCancelRoute
  '/payment/pro/success': typeof PaymentProSuccessRoute
  '/property/$propertyPublicId/guest-access': typeof PropertyPropertyPublicIdGuestAccessRoute
  '/_authenticated/setup/': typeof AuthenticatedSetupIndexRoute
  '/_authenticated/property/$propertyPublicId/archive': typeof AuthenticatedPropertyPropertyPublicIdArchiveRoute
  '/_authenticated/property/$propertyPublicId/records': typeof AuthenticatedPropertyPropertyPublicIdRecordsRoute
  '/_authenticated/property/$propertyPublicId/schedule': typeof AuthenticatedPropertyPropertyPublicIdScheduleRoute
  '/_authenticated/property/$propertyPublicId/service-providers': typeof AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute
  '/_authenticated/property/$propertyPublicId/settings': typeof AuthenticatedPropertyPropertyPublicIdSettingsRouteWithChildren
  '/_authenticated/property/$propertyPublicId/staged-documents': typeof AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute
  '/_authenticated/property/$propertyPublicId/': typeof AuthenticatedPropertyPropertyPublicIdIndexRoute
  '/_authenticated/property/$propertyPublicId/settings/access': typeof AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute
  '/_authenticated/property/$propertyPublicId/settings/transfer': typeof AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute
  '/_authenticated/property/$propertyPublicId/settings/': typeof AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/finalize-user'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/unauthorized'
    | '/dashboard'
    | '/maintenance'
    | '/profile-setup'
    | '/properties'
    | '/records'
    | '/service-providers'
    | '/settings'
    | '/setup'
    | '/tos-acceptance'
    | '/access/redeem'
    | '/payment/cancel'
    | '/payment/success'
    | '/oauth/consent'
    | '/property/$propertyPublicId'
    | '/settings/access'
    | '/settings/api-keys'
    | '/settings/profile'
    | '/settings/property'
    | '/settings/transfer'
    | '/setup/new'
    | '/access/$token/approve'
    | '/access/$token/deny'
    | '/payment/pro/cancel'
    | '/payment/pro/success'
    | '/property/$propertyPublicId/guest-access'
    | '/setup/'
    | '/property/$propertyPublicId/archive'
    | '/property/$propertyPublicId/records'
    | '/property/$propertyPublicId/schedule'
    | '/property/$propertyPublicId/service-providers'
    | '/property/$propertyPublicId/settings'
    | '/property/$propertyPublicId/staged-documents'
    | '/property/$propertyPublicId/'
    | '/property/$propertyPublicId/settings/access'
    | '/property/$propertyPublicId/settings/transfer'
    | '/property/$propertyPublicId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/finalize-user'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/unauthorized'
    | '/dashboard'
    | '/maintenance'
    | '/profile-setup'
    | '/properties'
    | '/records'
    | '/service-providers'
    | '/settings'
    | '/tos-acceptance'
    | '/access/redeem'
    | '/payment/cancel'
    | '/payment/success'
    | '/oauth/consent'
    | '/settings/access'
    | '/settings/api-keys'
    | '/settings/profile'
    | '/settings/property'
    | '/settings/transfer'
    | '/setup/new'
    | '/access/$token/approve'
    | '/access/$token/deny'
    | '/payment/pro/cancel'
    | '/payment/pro/success'
    | '/property/$propertyPublicId/guest-access'
    | '/setup'
    | '/property/$propertyPublicId/archive'
    | '/property/$propertyPublicId/records'
    | '/property/$propertyPublicId/schedule'
    | '/property/$propertyPublicId/service-providers'
    | '/property/$propertyPublicId/staged-documents'
    | '/property/$propertyPublicId'
    | '/property/$propertyPublicId/settings/access'
    | '/property/$propertyPublicId/settings/transfer'
    | '/property/$propertyPublicId/settings'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/finalize-user'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/unauthorized'
    | '/_authenticated/dashboard'
    | '/_authenticated/maintenance'
    | '/_authenticated/profile-setup'
    | '/_authenticated/properties'
    | '/_authenticated/records'
    | '/_authenticated/service-providers'
    | '/_authenticated/settings'
    | '/_authenticated/setup'
    | '/_authenticated/tos-acceptance'
    | '/access/redeem'
    | '/payment/cancel'
    | '/payment/success'
    | '/_authenticated/oauth/consent'
    | '/_authenticated/property/$propertyPublicId'
    | '/_authenticated/settings/access'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/property'
    | '/_authenticated/settings/transfer'
    | '/_authenticated/setup/new'
    | '/access/$token/approve'
    | '/access/$token/deny'
    | '/payment/pro/cancel'
    | '/payment/pro/success'
    | '/property/$propertyPublicId/guest-access'
    | '/_authenticated/setup/'
    | '/_authenticated/property/$propertyPublicId/archive'
    | '/_authenticated/property/$propertyPublicId/records'
    | '/_authenticated/property/$propertyPublicId/schedule'
    | '/_authenticated/property/$propertyPublicId/service-providers'
    | '/_authenticated/property/$propertyPublicId/settings'
    | '/_authenticated/property/$propertyPublicId/staged-documents'
    | '/_authenticated/property/$propertyPublicId/'
    | '/_authenticated/property/$propertyPublicId/settings/access'
    | '/_authenticated/property/$propertyPublicId/settings/transfer'
    | '/_authenticated/property/$propertyPublicId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  FinalizeUserRoute: typeof FinalizeUserRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AccessRedeemRoute: typeof AccessRedeemRoute
  PaymentCancelRoute: typeof PaymentCancelRoute
  PaymentSuccessRoute: typeof PaymentSuccessRoute
  AccessTokenApproveRoute: typeof AccessTokenApproveRoute
  AccessTokenDenyRoute: typeof AccessTokenDenyRoute
  PaymentProCancelRoute: typeof PaymentProCancelRoute
  PaymentProSuccessRoute: typeof PaymentProSuccessRoute
  PropertyPropertyPublicIdGuestAccessRoute: typeof PropertyPropertyPublicIdGuestAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finalize-user': {
      id: '/finalize-user'
      path: '/finalize-user'
      fullPath: '/finalize-user'
      preLoaderRoute: typeof FinalizeUserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/success': {
      id: '/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof PaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/cancel': {
      id: '/payment/cancel'
      path: '/payment/cancel'
      fullPath: '/payment/cancel'
      preLoaderRoute: typeof PaymentCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access/redeem': {
      id: '/access/redeem'
      path: '/access/redeem'
      fullPath: '/access/redeem'
      preLoaderRoute: typeof AccessRedeemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/tos-acceptance': {
      id: '/_authenticated/tos-acceptance'
      path: '/tos-acceptance'
      fullPath: '/tos-acceptance'
      preLoaderRoute: typeof AuthenticatedTosAcceptanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup': {
      id: '/_authenticated/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthenticatedSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-providers': {
      id: '/_authenticated/service-providers'
      path: '/service-providers'
      fullPath: '/service-providers'
      preLoaderRoute: typeof AuthenticatedServiceProvidersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/records': {
      id: '/_authenticated/records'
      path: '/records'
      fullPath: '/records'
      preLoaderRoute: typeof AuthenticatedRecordsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/properties': {
      id: '/_authenticated/properties'
      path: '/properties'
      fullPath: '/properties'
      preLoaderRoute: typeof AuthenticatedPropertiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile-setup': {
      id: '/_authenticated/profile-setup'
      path: '/profile-setup'
      fullPath: '/profile-setup'
      preLoaderRoute: typeof AuthenticatedProfileSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/maintenance': {
      id: '/_authenticated/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof AuthenticatedMaintenanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup/': {
      id: '/_authenticated/setup/'
      path: '/'
      fullPath: '/setup/'
      preLoaderRoute: typeof AuthenticatedSetupIndexRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/property/$propertyPublicId/guest-access': {
      id: '/property/$propertyPublicId/guest-access'
      path: '/property/$propertyPublicId/guest-access'
      fullPath: '/property/$propertyPublicId/guest-access'
      preLoaderRoute: typeof PropertyPropertyPublicIdGuestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/pro/success': {
      id: '/payment/pro/success'
      path: '/payment/pro/success'
      fullPath: '/payment/pro/success'
      preLoaderRoute: typeof PaymentProSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/pro/cancel': {
      id: '/payment/pro/cancel'
      path: '/payment/pro/cancel'
      fullPath: '/payment/pro/cancel'
      preLoaderRoute: typeof PaymentProCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access/$token/deny': {
      id: '/access/$token/deny'
      path: '/access/$token/deny'
      fullPath: '/access/$token/deny'
      preLoaderRoute: typeof AccessTokenDenyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access/$token/approve': {
      id: '/access/$token/approve'
      path: '/access/$token/approve'
      fullPath: '/access/$token/approve'
      preLoaderRoute: typeof AccessTokenApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/setup/new': {
      id: '/_authenticated/setup/new'
      path: '/new'
      fullPath: '/setup/new'
      preLoaderRoute: typeof AuthenticatedSetupNewRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/settings/transfer': {
      id: '/_authenticated/settings/transfer'
      path: '/transfer'
      fullPath: '/settings/transfer'
      preLoaderRoute: typeof AuthenticatedSettingsTransferRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/property': {
      id: '/_authenticated/settings/property'
      path: '/property'
      fullPath: '/settings/property'
      preLoaderRoute: typeof AuthenticatedSettingsPropertyRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/access': {
      id: '/_authenticated/settings/access'
      path: '/access'
      fullPath: '/settings/access'
      preLoaderRoute: typeof AuthenticatedSettingsAccessRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/property/$propertyPublicId': {
      id: '/_authenticated/property/$propertyPublicId'
      path: '/property/$propertyPublicId'
      fullPath: '/property/$propertyPublicId'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/oauth/consent': {
      id: '/_authenticated/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof AuthenticatedOauthConsentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/property/$propertyPublicId/': {
      id: '/_authenticated/property/$propertyPublicId/'
      path: '/'
      fullPath: '/property/$propertyPublicId/'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdIndexRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/staged-documents': {
      id: '/_authenticated/property/$propertyPublicId/staged-documents'
      path: '/staged-documents'
      fullPath: '/property/$propertyPublicId/staged-documents'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdStagedDocumentsRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/settings': {
      id: '/_authenticated/property/$propertyPublicId/settings'
      path: '/settings'
      fullPath: '/property/$propertyPublicId/settings'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/service-providers': {
      id: '/_authenticated/property/$propertyPublicId/service-providers'
      path: '/service-providers'
      fullPath: '/property/$propertyPublicId/service-providers'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdServiceProvidersRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/schedule': {
      id: '/_authenticated/property/$propertyPublicId/schedule'
      path: '/schedule'
      fullPath: '/property/$propertyPublicId/schedule'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdScheduleRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/records': {
      id: '/_authenticated/property/$propertyPublicId/records'
      path: '/records'
      fullPath: '/property/$propertyPublicId/records'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdRecordsRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/archive': {
      id: '/_authenticated/property/$propertyPublicId/archive'
      path: '/archive'
      fullPath: '/property/$propertyPublicId/archive'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdArchiveRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdRoute
    }
    '/_authenticated/property/$propertyPublicId/settings/': {
      id: '/_authenticated/property/$propertyPublicId/settings/'
      path: '/'
      fullPath: '/property/$propertyPublicId/settings/'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsRoute
    }
    '/_authenticated/property/$propertyPublicId/settings/transfer': {
      id: '/_authenticated/property/$propertyPublicId/settings/transfer'
      path: '/transfer'
      fullPath: '/property/$propertyPublicId/settings/transfer'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsTransferRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsRoute
    }
    '/_authenticated/property/$propertyPublicId/settings/access': {
      id: '/_authenticated/property/$propertyPublicId/settings/access'
      path: '/access'
      fullPath: '/property/$propertyPublicId/settings/access'
      preLoaderRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsAccessRouteImport
      parentRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsRoute
    }
  }
}

declare module './routes/index' {
  const createFileRoute: CreateFileRoute<
    '/',
    FileRoutesByPath['/']['parentRoute'],
    FileRoutesByPath['/']['id'],
    FileRoutesByPath['/']['path'],
    FileRoutesByPath['/']['fullPath']
  >
}
declare module './routes/_authenticated' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated',
    FileRoutesByPath['/_authenticated']['parentRoute'],
    FileRoutesByPath['/_authenticated']['id'],
    FileRoutesByPath['/_authenticated']['path'],
    FileRoutesByPath['/_authenticated']['fullPath']
  >
}
declare module './routes/finalize-user' {
  const createFileRoute: CreateFileRoute<
    '/finalize-user',
    FileRoutesByPath['/finalize-user']['parentRoute'],
    FileRoutesByPath['/finalize-user']['id'],
    FileRoutesByPath['/finalize-user']['path'],
    FileRoutesByPath['/finalize-user']['fullPath']
  >
}
declare module './routes/forgot-password' {
  const createFileRoute: CreateFileRoute<
    '/forgot-password',
    FileRoutesByPath['/forgot-password']['parentRoute'],
    FileRoutesByPath['/forgot-password']['id'],
    FileRoutesByPath['/forgot-password']['path'],
    FileRoutesByPath['/forgot-password']['fullPath']
  >
}
declare module './routes/login' {
  const createFileRoute: CreateFileRoute<
    '/login',
    FileRoutesByPath['/login']['parentRoute'],
    FileRoutesByPath['/login']['id'],
    FileRoutesByPath['/login']['path'],
    FileRoutesByPath['/login']['fullPath']
  >
}
declare module './routes/register' {
  const createFileRoute: CreateFileRoute<
    '/register',
    FileRoutesByPath['/register']['parentRoute'],
    FileRoutesByPath['/register']['id'],
    FileRoutesByPath['/register']['path'],
    FileRoutesByPath['/register']['fullPath']
  >
}
declare module './routes/reset-password' {
  const createFileRoute: CreateFileRoute<
    '/reset-password',
    FileRoutesByPath['/reset-password']['parentRoute'],
    FileRoutesByPath['/reset-password']['id'],
    FileRoutesByPath['/reset-password']['path'],
    FileRoutesByPath['/reset-password']['fullPath']
  >
}
declare module './routes/unauthorized' {
  const createFileRoute: CreateFileRoute<
    '/unauthorized',
    FileRoutesByPath['/unauthorized']['parentRoute'],
    FileRoutesByPath['/unauthorized']['id'],
    FileRoutesByPath['/unauthorized']['path'],
    FileRoutesByPath['/unauthorized']['fullPath']
  >
}
declare module './routes/_authenticated/dashboard' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/dashboard',
    FileRoutesByPath['/_authenticated/dashboard']['parentRoute'],
    FileRoutesByPath['/_authenticated/dashboard']['id'],
    FileRoutesByPath['/_authenticated/dashboard']['path'],
    FileRoutesByPath['/_authenticated/dashboard']['fullPath']
  >
}
declare module './routes/_authenticated/maintenance' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/maintenance',
    FileRoutesByPath['/_authenticated/maintenance']['parentRoute'],
    FileRoutesByPath['/_authenticated/maintenance']['id'],
    FileRoutesByPath['/_authenticated/maintenance']['path'],
    FileRoutesByPath['/_authenticated/maintenance']['fullPath']
  >
}
declare module './routes/_authenticated/profile-setup' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/profile-setup',
    FileRoutesByPath['/_authenticated/profile-setup']['parentRoute'],
    FileRoutesByPath['/_authenticated/profile-setup']['id'],
    FileRoutesByPath['/_authenticated/profile-setup']['path'],
    FileRoutesByPath['/_authenticated/profile-setup']['fullPath']
  >
}
declare module './routes/_authenticated/properties' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/properties',
    FileRoutesByPath['/_authenticated/properties']['parentRoute'],
    FileRoutesByPath['/_authenticated/properties']['id'],
    FileRoutesByPath['/_authenticated/properties']['path'],
    FileRoutesByPath['/_authenticated/properties']['fullPath']
  >
}
declare module './routes/_authenticated/records' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/records',
    FileRoutesByPath['/_authenticated/records']['parentRoute'],
    FileRoutesByPath['/_authenticated/records']['id'],
    FileRoutesByPath['/_authenticated/records']['path'],
    FileRoutesByPath['/_authenticated/records']['fullPath']
  >
}
declare module './routes/_authenticated/service-providers' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/service-providers',
    FileRoutesByPath['/_authenticated/service-providers']['parentRoute'],
    FileRoutesByPath['/_authenticated/service-providers']['id'],
    FileRoutesByPath['/_authenticated/service-providers']['path'],
    FileRoutesByPath['/_authenticated/service-providers']['fullPath']
  >
}
declare module './routes/_authenticated/settings' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings',
    FileRoutesByPath['/_authenticated/settings']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings']['id'],
    FileRoutesByPath['/_authenticated/settings']['path'],
    FileRoutesByPath['/_authenticated/settings']['fullPath']
  >
}
declare module './routes/_authenticated/setup' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/setup',
    FileRoutesByPath['/_authenticated/setup']['parentRoute'],
    FileRoutesByPath['/_authenticated/setup']['id'],
    FileRoutesByPath['/_authenticated/setup']['path'],
    FileRoutesByPath['/_authenticated/setup']['fullPath']
  >
}
declare module './routes/_authenticated/tos-acceptance' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/tos-acceptance',
    FileRoutesByPath['/_authenticated/tos-acceptance']['parentRoute'],
    FileRoutesByPath['/_authenticated/tos-acceptance']['id'],
    FileRoutesByPath['/_authenticated/tos-acceptance']['path'],
    FileRoutesByPath['/_authenticated/tos-acceptance']['fullPath']
  >
}
declare module './routes/access/redeem' {
  const createFileRoute: CreateFileRoute<
    '/access/redeem',
    FileRoutesByPath['/access/redeem']['parentRoute'],
    FileRoutesByPath['/access/redeem']['id'],
    FileRoutesByPath['/access/redeem']['path'],
    FileRoutesByPath['/access/redeem']['fullPath']
  >
}
declare module './routes/payment/cancel' {
  const createFileRoute: CreateFileRoute<
    '/payment/cancel',
    FileRoutesByPath['/payment/cancel']['parentRoute'],
    FileRoutesByPath['/payment/cancel']['id'],
    FileRoutesByPath['/payment/cancel']['path'],
    FileRoutesByPath['/payment/cancel']['fullPath']
  >
}
declare module './routes/payment/success' {
  const createFileRoute: CreateFileRoute<
    '/payment/success',
    FileRoutesByPath['/payment/success']['parentRoute'],
    FileRoutesByPath['/payment/success']['id'],
    FileRoutesByPath['/payment/success']['path'],
    FileRoutesByPath['/payment/success']['fullPath']
  >
}
declare module './routes/_authenticated/oauth/consent' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/oauth/consent',
    FileRoutesByPath['/_authenticated/oauth/consent']['parentRoute'],
    FileRoutesByPath['/_authenticated/oauth/consent']['id'],
    FileRoutesByPath['/_authenticated/oauth/consent']['path'],
    FileRoutesByPath['/_authenticated/oauth/consent']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId']['fullPath']
  >
}
declare module './routes/_authenticated/settings/access' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings/access',
    FileRoutesByPath['/_authenticated/settings/access']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings/access']['id'],
    FileRoutesByPath['/_authenticated/settings/access']['path'],
    FileRoutesByPath['/_authenticated/settings/access']['fullPath']
  >
}
declare module './routes/_authenticated/settings/api-keys' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings/api-keys',
    FileRoutesByPath['/_authenticated/settings/api-keys']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings/api-keys']['id'],
    FileRoutesByPath['/_authenticated/settings/api-keys']['path'],
    FileRoutesByPath['/_authenticated/settings/api-keys']['fullPath']
  >
}
declare module './routes/_authenticated/settings/profile' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings/profile',
    FileRoutesByPath['/_authenticated/settings/profile']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings/profile']['id'],
    FileRoutesByPath['/_authenticated/settings/profile']['path'],
    FileRoutesByPath['/_authenticated/settings/profile']['fullPath']
  >
}
declare module './routes/_authenticated/settings/property' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings/property',
    FileRoutesByPath['/_authenticated/settings/property']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings/property']['id'],
    FileRoutesByPath['/_authenticated/settings/property']['path'],
    FileRoutesByPath['/_authenticated/settings/property']['fullPath']
  >
}
declare module './routes/_authenticated/settings/transfer' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/settings/transfer',
    FileRoutesByPath['/_authenticated/settings/transfer']['parentRoute'],
    FileRoutesByPath['/_authenticated/settings/transfer']['id'],
    FileRoutesByPath['/_authenticated/settings/transfer']['path'],
    FileRoutesByPath['/_authenticated/settings/transfer']['fullPath']
  >
}
declare module './routes/_authenticated/setup/new' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/setup/new',
    FileRoutesByPath['/_authenticated/setup/new']['parentRoute'],
    FileRoutesByPath['/_authenticated/setup/new']['id'],
    FileRoutesByPath['/_authenticated/setup/new']['path'],
    FileRoutesByPath['/_authenticated/setup/new']['fullPath']
  >
}
declare module './routes/access/$token/approve' {
  const createFileRoute: CreateFileRoute<
    '/access/$token/approve',
    FileRoutesByPath['/access/$token/approve']['parentRoute'],
    FileRoutesByPath['/access/$token/approve']['id'],
    FileRoutesByPath['/access/$token/approve']['path'],
    FileRoutesByPath['/access/$token/approve']['fullPath']
  >
}
declare module './routes/access/$token/deny' {
  const createFileRoute: CreateFileRoute<
    '/access/$token/deny',
    FileRoutesByPath['/access/$token/deny']['parentRoute'],
    FileRoutesByPath['/access/$token/deny']['id'],
    FileRoutesByPath['/access/$token/deny']['path'],
    FileRoutesByPath['/access/$token/deny']['fullPath']
  >
}
declare module './routes/payment/pro/cancel' {
  const createFileRoute: CreateFileRoute<
    '/payment/pro/cancel',
    FileRoutesByPath['/payment/pro/cancel']['parentRoute'],
    FileRoutesByPath['/payment/pro/cancel']['id'],
    FileRoutesByPath['/payment/pro/cancel']['path'],
    FileRoutesByPath['/payment/pro/cancel']['fullPath']
  >
}
declare module './routes/payment/pro/success' {
  const createFileRoute: CreateFileRoute<
    '/payment/pro/success',
    FileRoutesByPath['/payment/pro/success']['parentRoute'],
    FileRoutesByPath['/payment/pro/success']['id'],
    FileRoutesByPath['/payment/pro/success']['path'],
    FileRoutesByPath['/payment/pro/success']['fullPath']
  >
}
declare module './routes/property/$propertyPublicId/guest-access' {
  const createFileRoute: CreateFileRoute<
    '/property/$propertyPublicId/guest-access',
    FileRoutesByPath['/property/$propertyPublicId/guest-access']['parentRoute'],
    FileRoutesByPath['/property/$propertyPublicId/guest-access']['id'],
    FileRoutesByPath['/property/$propertyPublicId/guest-access']['path'],
    FileRoutesByPath['/property/$propertyPublicId/guest-access']['fullPath']
  >
}
declare module './routes/_authenticated/setup/index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/setup/',
    FileRoutesByPath['/_authenticated/setup/']['parentRoute'],
    FileRoutesByPath['/_authenticated/setup/']['id'],
    FileRoutesByPath['/_authenticated/setup/']['path'],
    FileRoutesByPath['/_authenticated/setup/']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/archive' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/archive',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/archive']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/archive']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/archive']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/archive']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/records' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/records',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/records']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/records']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/records']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/records']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/schedule' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/schedule',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/schedule']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/schedule']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/schedule']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/schedule']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/service-providers' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/service-providers',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/service-providers']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/service-providers']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/service-providers']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/service-providers']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/settings' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/settings',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/staged-documents' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/staged-documents',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/staged-documents']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/staged-documents']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/staged-documents']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/staged-documents']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/settings/access' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/settings/access',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/access']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/access']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/access']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/access']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/settings/transfer' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/settings/transfer',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/transfer']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/transfer']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/transfer']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/transfer']['fullPath']
  >
}
declare module './routes/_authenticated/property/$propertyPublicId/settings/index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/property/$propertyPublicId/settings/',
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/']['parentRoute'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/']['id'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/']['path'],
    FileRoutesByPath['/_authenticated/property/$propertyPublicId/settings/']['fullPath']
  >
}

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccessRoute: typeof AuthenticatedSettingsAccessRoute
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsPropertyRoute: typeof AuthenticatedSettingsPropertyRoute
  AuthenticatedSettingsTransferRoute: typeof AuthenticatedSettingsTransferRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccessRoute: AuthenticatedSettingsAccessRoute,
  AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsPropertyRoute: AuthenticatedSettingsPropertyRoute,
  AuthenticatedSettingsTransferRoute: AuthenticatedSettingsTransferRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedSetupRouteChildren {
  AuthenticatedSetupNewRoute: typeof AuthenticatedSetupNewRoute
  AuthenticatedSetupIndexRoute: typeof AuthenticatedSetupIndexRoute
}

const AuthenticatedSetupRouteChildren: AuthenticatedSetupRouteChildren = {
  AuthenticatedSetupNewRoute: AuthenticatedSetupNewRoute,
  AuthenticatedSetupIndexRoute: AuthenticatedSetupIndexRoute,
}

const AuthenticatedSetupRouteWithChildren =
  AuthenticatedSetupRoute._addFileChildren(AuthenticatedSetupRouteChildren)

interface AuthenticatedPropertyPropertyPublicIdSettingsRouteChildren {
  AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute
  AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute
  AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute
}

const AuthenticatedPropertyPropertyPublicIdSettingsRouteChildren: AuthenticatedPropertyPropertyPublicIdSettingsRouteChildren =
  {
    AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute:
      AuthenticatedPropertyPropertyPublicIdSettingsAccessRoute,
    AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute:
      AuthenticatedPropertyPropertyPublicIdSettingsTransferRoute,
    AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute:
      AuthenticatedPropertyPropertyPublicIdSettingsIndexRoute,
  }

const AuthenticatedPropertyPropertyPublicIdSettingsRouteWithChildren =
  AuthenticatedPropertyPropertyPublicIdSettingsRoute._addFileChildren(
    AuthenticatedPropertyPropertyPublicIdSettingsRouteChildren,
  )

interface AuthenticatedPropertyPropertyPublicIdRouteChildren {
  AuthenticatedPropertyPropertyPublicIdArchiveRoute: typeof AuthenticatedPropertyPropertyPublicIdArchiveRoute
  AuthenticatedPropertyPropertyPublicIdRecordsRoute: typeof AuthenticatedPropertyPropertyPublicIdRecordsRoute
  AuthenticatedPropertyPropertyPublicIdScheduleRoute: typeof AuthenticatedPropertyPropertyPublicIdScheduleRoute
  AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute: typeof AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute
  AuthenticatedPropertyPropertyPublicIdSettingsRoute: typeof AuthenticatedPropertyPropertyPublicIdSettingsRouteWithChildren
  AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute: typeof AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute
  AuthenticatedPropertyPropertyPublicIdIndexRoute: typeof AuthenticatedPropertyPropertyPublicIdIndexRoute
}

const AuthenticatedPropertyPropertyPublicIdRouteChildren: AuthenticatedPropertyPropertyPublicIdRouteChildren =
  {
    AuthenticatedPropertyPropertyPublicIdArchiveRoute:
      AuthenticatedPropertyPropertyPublicIdArchiveRoute,
    AuthenticatedPropertyPropertyPublicIdRecordsRoute:
      AuthenticatedPropertyPropertyPublicIdRecordsRoute,
    AuthenticatedPropertyPropertyPublicIdScheduleRoute:
      AuthenticatedPropertyPropertyPublicIdScheduleRoute,
    AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute:
      AuthenticatedPropertyPropertyPublicIdServiceProvidersRoute,
    AuthenticatedPropertyPropertyPublicIdSettingsRoute:
      AuthenticatedPropertyPropertyPublicIdSettingsRouteWithChildren,
    AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute:
      AuthenticatedPropertyPropertyPublicIdStagedDocumentsRoute,
    AuthenticatedPropertyPropertyPublicIdIndexRoute:
      AuthenticatedPropertyPropertyPublicIdIndexRoute,
  }

const AuthenticatedPropertyPropertyPublicIdRouteWithChildren =
  AuthenticatedPropertyPropertyPublicIdRoute._addFileChildren(
    AuthenticatedPropertyPropertyPublicIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedMaintenanceRoute: typeof AuthenticatedMaintenanceRoute
  AuthenticatedProfileSetupRoute: typeof AuthenticatedProfileSetupRoute
  AuthenticatedPropertiesRoute: typeof AuthenticatedPropertiesRoute
  AuthenticatedRecordsRoute: typeof AuthenticatedRecordsRoute
  AuthenticatedServiceProvidersRoute: typeof AuthenticatedServiceProvidersRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSetupRoute: typeof AuthenticatedSetupRouteWithChildren
  AuthenticatedTosAcceptanceRoute: typeof AuthenticatedTosAcceptanceRoute
  AuthenticatedOauthConsentRoute: typeof AuthenticatedOauthConsentRoute
  AuthenticatedPropertyPropertyPublicIdRoute: typeof AuthenticatedPropertyPropertyPublicIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedMaintenanceRoute: AuthenticatedMaintenanceRoute,
  AuthenticatedProfileSetupRoute: AuthenticatedProfileSetupRoute,
  AuthenticatedPropertiesRoute: AuthenticatedPropertiesRoute,
  AuthenticatedRecordsRoute: AuthenticatedRecordsRoute,
  AuthenticatedServiceProvidersRoute: AuthenticatedServiceProvidersRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSetupRoute: AuthenticatedSetupRouteWithChildren,
  AuthenticatedTosAcceptanceRoute: AuthenticatedTosAcceptanceRoute,
  AuthenticatedOauthConsentRoute: AuthenticatedOauthConsentRoute,
  AuthenticatedPropertyPropertyPublicIdRoute:
    AuthenticatedPropertyPropertyPublicIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  FinalizeUserRoute: FinalizeUserRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AccessRedeemRoute: AccessRedeemRoute,
  PaymentCancelRoute: PaymentCancelRoute,
  PaymentSuccessRoute: PaymentSuccessRoute,
  AccessTokenApproveRoute: AccessTokenApproveRoute,
  AccessTokenDenyRoute: AccessTokenDenyRoute,
  PaymentProCancelRoute: PaymentProCancelRoute,
  PaymentProSuccessRoute: PaymentProSuccessRoute,
  PropertyPropertyPublicIdGuestAccessRoute:
    PropertyPropertyPublicIdGuestAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
